module.exports = __webpack_public_path__ + "img/JinGuaShihBanner.f30b42d6.png";